(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'wheel', 'touchmove', 'mousemove'];

(window as any).__Zone_disable_resizeObserver = true;
